import React from 'react';
import { includes } from 'lodash';
import InfoTable from '../../../../components/table/InfoTable';
import { setDash, setNumberWithComma } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import OpenReturnExchangeAttachment from '../../../../containers/app/common/OpenReturnExchangeAttachment';
import OpenOrderReturnItemDetail from '../../../../components/link/OpenOrderReturnItemDetail';
import {
  ORDER_ACCEPT_MANAGER_TEXT,
  ORDER_PROCESS_HISTORY_TYPE_TEXT,
  ORDER_RETURN_BUYER_RESPONSIBILITY_MANAGER,
  ORDER_RETURN_BUYER_RESPONSIBILITY_TYPE_LIST,
  ORDER_RETURN_SELLER_RESPONSIBILITY_MANAGER,
  ORDER_RETURN_STATUS,
  ORDER_RETURN_STATUS_TEXT,
  ORDER_RETURN_TYPE_TEXT,
  RETURN_EXCHANGE_REASON_TYPE,
} from '../../../../constants/service/app/orderConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import './OrderReturnHistory.scss';

const OrderReturnHistory = (props) => {
  const { returnHistory } = props;

  if (!returnHistory?.orderReturnHistory.length) return null;

  // 예상고객부담금
  const expectCustomerCharge =
    returnHistory.totalPrice - returnHistory.returnDeliveryFee < 0
      ? returnHistory.returnDeliveryFee - returnHistory.totalPrice
      : 0;
  // 판매자가 측정한 환불 금액 - 고객부담금
  const customerCharge =
    returnHistory.totalPrice - returnHistory.returnDeliveryFee < 0
      ? returnHistory.returnDeliveryFee - returnHistory.totalPrice + returnHistory.refundSellerAmount
      : 0;
  // 고객 예상 환불 금액
  const expectCustomerRefund = returnHistory.totalPrice - returnHistory.returnDeliveryFee + expectCustomerCharge;
  return (
    <div className="order-detail-content">
      {/*반품 기본, 요청, 승인, 완료 정보*/}
      <div className="order-detail-section">
        {/* 반품 기본 정보 */}
        <div className="title">반품 기본 정보</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">반품 처리 상태</td>
              <td className="tc">{ORDER_RETURN_STATUS_TEXT[returnHistory.orderReturnStatus]}</td>
              <td className="label tc">반품 번호</td>
              <td className="tc">
                {
                  /**
                   *  반품 승인, 반품 완료 일 경우에만
                   *  새로운 탭에서 반품 상세 페이지를 여는 anchor 노출
                   */
                  returnHistory.orderReturnStatus === ORDER_RETURN_STATUS.RETURN_DONE ||
                  returnHistory.orderReturnStatus === ORDER_RETURN_STATUS.REFUND_DONE ? (
                    <OpenOrderReturnItemDetail
                      text={returnHistory.orderReturnId}
                      orderItemId={returnHistory.orderItemId}
                    />
                  ) : (
                    returnHistory.orderReturnId
                  )
                }
              </td>
            </tr>
            <tr>
              <td className="label tc">반품 사유</td>
              <td className="tc">
                {
                  <OpenReturnExchangeAttachment
                    title="반품사유"
                    orderReturnExchangeId={returnHistory.orderReturnId}
                    type={RETURN_EXCHANGE_REASON_TYPE.RETURN_REQUEST}
                    text={ORDER_RETURN_TYPE_TEXT[returnHistory.returnType]}
                    reason={returnHistory.returnReason}
                  />
                }
              </td>
              <td className="label tc">접수자</td>
              <td className="tc">{setDash(ORDER_ACCEPT_MANAGER_TEXT[returnHistory.acceptManager])}</td>
            </tr>
            <tr>
              <td className="label tc">반품 귀책 대상</td>
              <td className="tc">
                {includes(ORDER_RETURN_BUYER_RESPONSIBILITY_TYPE_LIST, returnHistory.returnType)
                  ? ORDER_RETURN_BUYER_RESPONSIBILITY_MANAGER
                  : ORDER_RETURN_SELLER_RESPONSIBILITY_MANAGER}
              </td>
              <td className="label tc">반품 사유 수정 일시</td>
              <td className="tc">
                {setDateFormat(returnHistory.returnReasonModifyDate, DATE_FORMAT.YMD_HM_DASH_FORMAT)}
              </td>
            </tr>
            <tr>
              <td className="label tc"> 반품 거부 사유</td>
              <td className="tc" colSpan={3}>
                {
                  <OpenReturnExchangeAttachment
                    title="반품 거부사유"
                    orderReturnExchangeId={returnHistory.orderReturnId}
                    type={RETURN_EXCHANGE_REASON_TYPE.RETURN_REJECT}
                    text="사유 보기"
                    reason={returnHistory.rejectReason}
                  />
                }
              </td>
            </tr>
          </tbody>
        </InfoTable>

        {/* 반품 요청 정보 */}
        <div className="title">반품 요청 정보</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">고객 결제금액</td>
              <td className="tc">{setNumberWithComma(returnHistory.totalPrice, '원')}</td>
              <td className="label tc">
                고객 부담 <br /> 최초 무료배송비
              </td>
              <td className="tc">{setNumberWithComma(returnHistory.returnDeliveryFee, '원')}</td>
            </tr>
            <tr>
              <td className="label tc">(예상)고객부담금</td>
              <td className="tc">{setNumberWithComma(customerCharge, '원')}</td>
              <td className="label tc">고객 예상 환불금액</td>
              <td className="tc">{setNumberWithComma(expectCustomerRefund, '원')}</td>
            </tr>
          </tbody>
        </InfoTable>

        {/* 반품 승인 정보 */}
        <div className="title">반품 승인 정보</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">추가 청구비</td>
              <td className="tc">{setNumberWithComma(returnHistory.refundExtraFee, '원')}</td>
              <td className="label tc">판매자 설정 환불금액</td>
              <td className="tc">{setNumberWithComma(returnHistory.refundSellerAmount, '원')}</td>
            </tr>
            <tr>
              <td className="label tc">반품 승인 책정 사유</td>
              <td className="tc" colSpan={3}>
                {setDash(returnHistory.returnCompleteReason)}
              </td>
            </tr>
          </tbody>
        </InfoTable>

        {/* 반품 완료 정보 */}
        <div className="title">반품 완료 정보</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">
                구매자 부담 <br /> 추가 배송비
              </td>
              <td className="tc">{setNumberWithComma(returnHistory.buyerDeliveryExtraFee, '원')}</td>
              <td className="label tc">
                판매자 부담 <br /> 추가 배송비
              </td>
              <td className="tc">{setNumberWithComma(returnHistory.sellerDeliveryExtraFee, '원')}</td>
            </tr>
            <tr>
              <td className="label tc">실제 고객 환불 금액</td>
              <td className="tc">{setNumberWithComma(returnHistory.refundActualAmount, '원')}</td>
              <td className="label tc">판매자 정산 예정 금액</td>
              <td className="tc">{setNumberWithComma(returnHistory.sellerExpectBalanceAmount, '원')}</td>
            </tr>
            <tr>
              <td className="label tc">반품 완료 처리자</td>
              <td className="tc" colSpan={3}>
                {setDash(returnHistory.refundManager)}
              </td>
            </tr>
            <tr>
              <td className="label tc">반품 완료 책정 사유</td>
              <td className="tc" colSpan={3}>
                {setDash(returnHistory.refundCompleteReason)}
              </td>
            </tr>
            <tr>
              <td className="label tc">관리자 메모</td>
              <td className="tc" colSpan={3}>
                {setDash(returnHistory.adminMemo)}
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>

      {/* 반품 처리 이력 */}
      <div className="order-detail-section">
        <div className="title">반품 처리 이력</div>

        <div className="order-return-history-table">
          <InfoTable className="order-return-history" scroll={{ x: true }}>
            <thead>
              <tr>
                <th>상태</th>
                <th>처리일시</th>
                <th>사유</th>
              </tr>
            </thead>

            <tbody>
              {returnHistory.orderReturnHistory.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className="label tc">{ORDER_PROCESS_HISTORY_TYPE_TEXT[item.status]}</td>
                    <td className="tc">{setDateFormat(item.value, DATE_FORMAT.FULL_DASH_FORMAT)}</td>
                    <td className="tc">
                      {
                        <OpenReturnExchangeAttachment
                          title={item.type ? '반품사유' : '반품 거부사유'}
                          orderReturnExchangeId={item.orderReturnId}
                          type={
                            item.type
                              ? RETURN_EXCHANGE_REASON_TYPE.RETURN_REQUEST
                              : RETURN_EXCHANGE_REASON_TYPE.RETURN_REJECT
                          }
                          text={item.type ? item.type : '사유 보기'}
                          reason={item.reason}
                        />
                      }
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </InfoTable>
        </div>
      </div>
    </div>
  );
};

export default OrderReturnHistory;
